import React from 'react'
import reducer, { initialState } from './SharedBrowserReducer'

/**
 * @typedef {import('./SharedBrowserReducer').SharedBrowserState} SharedBrowserState
 */

export const SharedBrowserStateContext = React.createContext(null)
export const SharedBrowserDispatchContext = React.createContext(null)

export default function SharedBrowserProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  return (
    <SharedBrowserStateContext.Provider value={state}>
      <SharedBrowserDispatchContext.Provider value={dispatch}>{children}</SharedBrowserDispatchContext.Provider>
    </SharedBrowserStateContext.Provider>
  )
}

export const useSharedBrowserDispatchContext = () => {
  const sharedBrowserDispatch = React.useContext(SharedBrowserDispatchContext)
  if (!sharedBrowserDispatch) {
    throw new Error('useSharedBrowserDispatch must be used within a SharedBrowserStateProvider')
  }
  return sharedBrowserDispatch
}

/** @returns {SharedBrowserState} */
export const useSharedBrowserStateContext = () => {
  const sharedBrowserState = React.useContext(SharedBrowserStateContext)
  if (!sharedBrowserState) {
    throw new Error('useSharedBrowserState must be used within a SharedBrowserStateProvider')
  }
  return sharedBrowserState
}
